<template>
  <div class="biz-chart-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1 />
      <span>协议指标签订率</span>
    </div>
    <div ref="chart" class="biz-chart-container"></div>
  </div>
</template>

<script>
import resize from '@/utils/resize'

export default {
  name: 'BizAgentSigning',
  mixins: [resize],
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    chartData: {
      handler(v) {
        if (v && v.length) this.initChart()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.chartData && this.chartData.length) this.initChart()
    })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return
      if (this.chart) {
        this.chart.dispose()
      }
      this.chart = this.$echarts.init(this.$refs.chart)
      const data = this.chartData
      const regions = data.map(d => d.region || '')
      const assessmentTargets = data.map(d => d.assessmentTarget || 0)
      const signedTargets = data.map(d => d.signedTarget || 0)
      const signingRates = data.map(d => d.signingRate || 0)
      const option = {
        color: ['#EF557D', '#24CBF1', '#E6A23C'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00f2fe',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: ['考核指标', '签订指标', '签订率'],
          textStyle: { color: '#fff', fontSize: 11 },
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: regions,
          axisLabel: { color: '#fff', fontSize: 11, interval: 0, rotate: regions.length > 6 ? 30 : 0 },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '指标数',
            nameTextStyle: { color: '#fff', fontSize: 11 },
            axisLabel: { color: '#fff', fontSize: 11 },
            splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
            axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
          },
          {
            type: 'value',
            name: '签订率(%)',
            max: 100,
            nameTextStyle: { color: '#fff', fontSize: 11 },
            axisLabel: { formatter: '{value}%', color: '#fff', fontSize: 11 },
            splitLine: { show: false },
            axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
          }
        ],
        series: [
          {
            name: '考核指标',
            type: 'bar',
            data: assessmentTargets,
            itemStyle: { color: 'rgba(239, 85, 125, 0.7)' },
            barWidth: '25%',
            barGap: '10%'
          },
          {
            name: '签订指标',
            type: 'bar',
            data: signedTargets,
            itemStyle: { color: 'rgba(36, 203, 241, 0.7)' },
            barWidth: '25%'
          },
          {
            name: '签订率',
            type: 'line',
            yAxisIndex: 1,
            data: signingRates,
            itemStyle: { color: '#E6A23C' },
            lineStyle: { width: 3, color: '#E6A23C' },
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.biz-chart-box {
  background: rgba(10, 57, 130, 0.6);
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .chart-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bolder;
    padding: 8px 15px;
    background: rgba(10, 57, 130, 0.6);
    position: relative;
    flex-shrink: 0;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .dv-decoration-1 {
      width: 60px;
      height: 20px;
      margin-left: 40px;
    }

    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }

  .biz-chart-container {
    flex: 1;
    width: 100%;
    min-height: 0;
  }
}
</style>
